// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layouts-error-layout-caoze{align-items:center;display:flex;justify-content:center;padding:30px 0;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": "layouts-error-layout-caoze"
};
module.exports = ___CSS_LOADER_EXPORT___;
